<header class="menu-header">
	<div class="menu-icon">
	</div>

	<div class="menu-logo app-logo">
		<img ngSrc="{{ assetsPath }}/assets/images/logos/logo_aston_ai_white.png" [width]="125" [height]="29" [alt]="'App.Name' | translate">
	</div>
</header>

<ng-content select="[menu-content]">
</ng-content>
